export default __webpack_public_path__ + "static/media/meeting-res.8ca59b50.svg";